import { SoccerPlayerLabelType } from "../../types";

export interface SoccerPlayerIdToLabelProps {
  labelType: SoccerPlayerLabelType;
}

export const getSoccerPlayerPosLabel = (playerId: number): string => {
  switch (playerId) {
    case 1:
      return "D";
    case 2:
      return "D";
    case 3:
      return "D";
    case 4:
      return "D";
    case 5:
      return "M";
    case 6:
      return "M";
    case 7:
      return "M";
    case 8:
      return "M";
    case 9:
      return "F";
    case 10:
      return "F";
    case 11:
      return "GK";

    default:
      return "F";
  }
};

export const getSoccerPlayerLabel = ({ labelType }: SoccerPlayerIdToLabelProps): ((playerId: number) => string) => {
  switch (labelType) {
    case "POS":
      return getSoccerPlayerPosLabel;

    case "NUM":
      return (playerId: number): string => `${playerId}`;

    case "o":
      return () => "o";
  }
};
